<template>
  <b-modal id="patient-sms-modal"
           v-if="patient"
           @hide="onHide"
           :title="`${$t('sms_sending')} - ${patient.full_name}`"
           centered>
    <div class="row">
      <div class="col-6">
        <div>{{ $t('patient_number') }}:</div>
        <div>
          <a :href="`tel:${phoneNumber}`">{{ phoneNumber }}</a>
        </div>
      </div>
      <div class="col-6" v-if="smsInfo && !smsInfo.sms_settings">
        <div>{{ $t('sms_available') }}:</div>
        <div>{{ smsInfo.sms_available }}</div>
      </div>
    </div>
    <div class="mt-4">
      <label class="form-label">
        <span>{{ $t('message') }} *</span>
      </label>
      <TemplateGroup v-model="message"
                     :dictation="true"
                     :label="$t('message')"
                     :saveAsTemplate="true"
                     model="sms_template"/>
    </div>
    <template #modal-footer="{ close }">
      <div class="w-100">
        <div class="row align-items-center">
          <div class="col-md col-12">
            {{ $t('symbols_amount') }}: {{ message.length }}
          </div>
          <div class="mt-md-0 mt-3 text-right col-md-auto col-12">
            <div class="modal-footer-buttons">
              <b-button class="cancel mr-3 d-inline-block align-middle"
                        variant="themed"
                        @click="close()">
                {{ $t('cancel') }}
              </b-button>

              <button @click="send"
                      v-if="smsInfo"
                      :disabled="message.length < 1 || (messagesCount > smsInfo.sms_available && !smsInfo.sms_settings)"
                      class="w-auto px-3 btn-themed align-middle btn-themed-squared">
                {{ $t('send') }} ({{ messagesCount }} {{ $t('un') }})
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script setup>
import { useStore } from "vuex"
import TemplateGroup from "@/components/form/TemplateGroup"
import { SendService } from "@/services/api/send.api.service"
import { computed, getCurrentInstance, onBeforeMount, ref } from "vue"

const props = defineProps({
  specifiedPhone: {
    type: String,
    default: null
  }
})

const store = useStore()

let i18n = null
let noty = null
let bvModal = null

const message = ref('')
const perMessage = ref(70)

const patient = computed(() => store.state.patient.patient)
const clinic = computed(() => store.state.auth.clinic)

const smsInfo = computed(() => {
  return clinic.value && clinic.value.sms_info ? clinic.value.sms_info : null
})
const messagesCount = computed(() => Math.ceil(message.value.length / perMessage.value))
const phoneNumber = computed(() => props.specifiedPhone || patient.value.mphone)

onBeforeMount(() => {
  const instance = getCurrentInstance()
  i18n = instance?.ctx?.$i18n
  noty = instance?.appContext?.app?.noty
  bvModal = instance?.ctx?._bv__modal
})

const send = async () => {
  try {
    const res = await SendService.sendSMS({
      client_id: patient.value.id,
      phone: phoneNumber.value,
      message: message.value
    })
    if(res.data.success) {
      noty.info(18n.t('success_message'))
      message.value = ''
      bvModal.hide('patient-sms-modal')
      await store.dispatch('init')
    } else {
      noty.error(res.data.message?.message || res.data.message || res.data.error || i18n.t('server_error'))
    }
  } catch (e) {
    console.log(e)
  }
}

const onHide = () => {
  message.value = ''
}
</script>
